import PropTypes from "prop-types";
import React from "react";
import {Tab, Tabs} from "@mui/material";
import TabBarBase from "../../../../lib/components/tabbar/TabBarBase";
import VerticalLayout from "../../../../lib/components/layouts/VerticalLayout";
import HorizontalLayout from "../../../../lib/components/layouts/HorizontalLayout";

class VerticalTabBar extends TabBarBase {

  render() {
    let tabs = this.state.tabs.map((tab) => (<Tab key={tab.id}
                                                  selected={tab.id === this.state.activeTabId}
                                                  component={() => React.cloneElement(tab.tab, {
                                                    id: tab.id,
                                                    activeTabId: this.state.activeTabId,
                                                    onTabClick: (id) => this.onTabClick(id),
                                                    onRemoveClick: (id) => this.onRemoveClick(id)
                                                  })}/>));

    let contents = this.state.tabs.map((tab) => (<div className='h-full'
                                                      key={tab.id}
                                                      style={{display: tab.id === this.state.activeTabId ? '' : 'none'}}>
      {React.cloneElement(tab.tabContent, {id: tab.id, activeTabId: this.state.activeTabId, onRemoveClick: (id) => this.onRemoveClick(id)})}
    </div>));

    return <HorizontalLayout className={'CNINFO-VerticalTabBar h-full ' + this.props.className}>
      <VerticalLayout widthFit={false} className='h-full overflow-y-scroll'>
        <Tabs orientation='vertical' value={this.getArrayTabIndex(this.state.activeTabId)}>
          {tabs}
        </Tabs>
      </VerticalLayout>
      <VerticalLayout className='h-full overflow-y-scroll'>
        {contents}
      </VerticalLayout>
    </HorizontalLayout>;
  }
}

VerticalTabBar.propTypes = {
  className: PropTypes.string
};
export default VerticalTabBar;
